import { create } from 'zustand';
import MuvikaService from './../services/muvika';
import messageStore from './message';

const initialState = {
  isSet: false,
  isWaiting: false,
  currentPage: 1,
  news: null,
  isFinished: false
}

const newsStore = create((set, get) => ({
  ...initialState,
  reset: () => { 
    set(initialState)
  },
  resetNews: () => { 
    set({isSet: false, isWaiting: true, news: null});
  },
  getNews: (sessionToken, pageSize) => {
set({ currentPage: 1, isWaiting: true, isFinished: false });
    MuvikaService.getNews(sessionToken, pageSize, 1)
      .then(function (res) {
        if (res.data.error) {
          set({ isSet: false, totalCount: 0, isWaiting: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          set({ isSet: true, news: res.data.data.items, isWaiting: false });
        }
      })
      .catch(function(){});
  },
  getNewsMore: (sessionToken, pageSize) => {
let page = get().currentPage + 1;
    set({ currentPage: page, isWaiting: true });
    MuvikaService.getNews(sessionToken, pageSize, page)
      .then(function (res) {
        if (res.data.error) {
          set({ isSet: false, isWaiting: false });
          messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
        } else {
          let news = get().news;
          let newsMore = res.data.data.items;
          if (newsMore.length == 0) {
            set({ isFinished: true });
          }
          news = news.concat(newsMore);
          set({ isSet: true, news: news, isWaiting: false });
        }
      })
      .catch(function(){});
  }
}));

export default newsStore;